<div class="header-action-wrapper" [class.has-filter]="appliedFiltersCount > 0">
  <mat-icon
    *ngIf="appliedFiltersCount > 0"
    svgIcon="funnel"
    class="header-filter-indicator arrow-blue"
  ></mat-icon>
  <button
    class="header-action-btn"
    type="button"
    mat-button
    [matMenuTriggerFor]="headerMenu"
    [class.menu-open]="activeMenuColumn === columnName"
    #menuTrigger="matMenuTrigger"
    (menuOpened)="onHeaderMenuOpened()"
    (menuClosed)="onHeaderMenuClosed()"
  >
    <mat-icon
      *ngIf="currentSortColumn === columnName && currentSortDirection === 'asc'"
      svgIcon="arrow-up"
      class="sort-icon arrow-blue"
    ></mat-icon>
    <mat-icon
      *ngIf="currentSortColumn === columnName && currentSortDirection === 'desc'"
      svgIcon="arrow-down"
      class="sort-icon arrow-blue"
    ></mat-icon>
    <mat-icon
      *ngIf="currentSortColumn !== columnName"
      svgIcon="ellipsis"
      class="three-points-icon"
    ></mat-icon>
  </button>
</div>

<mat-menu #headerMenu="matMenu" class="header-menu-mat" yPosition="below" xPosition="after">
  <button mat-menu-item (click)="onMenuItemClick('asc')">
    <span>Sort ascending</span>
  </button>

  <button mat-menu-item (click)="onMenuItemClick('desc')">
    <span>Sort descending</span>
  </button>

  <mat-divider></mat-divider>

  <button
    mat-menu-item
    class="filter-option"
    [matMenuTriggerFor]="filterMenu"
    *ngIf="availableFilters.length > 0"
  >
    <span>Filter by</span>
  </button>
</mat-menu>

<mat-menu #filterMenu="matMenu" class="filter-submenu" yPosition="below" xPosition="after">
  <div class="filter-content" (click)="$event.stopPropagation()">
    <div class="filter-list">
      <mat-checkbox
        *ngFor="let filter of availableFilters; trackBy: trackByFilter"
        [checked]="isFilterSelected(filter)"
        (change)="onFilterToggle(filter, $event)"
        class="filter-checkbox {{ field }}"
        [value]="filter"
      >
        {{ filter }}
      </mat-checkbox>
    </div>

    <div class="filter-footer">
      <div class="filter-count">
        <span>{{ selectedFiltersCount }} selected</span>
      </div>
      <div class="filter-actions">
        <button mat-button color="primary" (click)="onFilterApply()">Apply</button>
        <button mat-button (click)="onFilterClear()">Clear All</button>
      </div>
    </div>
  </div>
</mat-menu>
